export default {
  statistics: {
    total_campaigns: 'Campagne totali',
    todays_sent_messages: 'Messaggi inviati oggi',
    total_subscribers: 'Iscritti',
    average_click_rate: 'Tasso di clic medio',
  },
};
